import styled from 'styled-components/macro';

export const PdfHolder = styled.div`
  /* width: 100%;
  position: relative;
  height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 14px;
  line-height: 20px; */
  position: relative;
  width: 100%;
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
`;

export const TeamConditionModal = styled.div`
  position: relative;
  width: 100%;
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  color: var(--primary-text-color);
`;

export const TextHolder = styled.div`
  width: 100%;
  position: relative;
  height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-text-color);
  margin-bottom: 10px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 10px 8px;
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  p {
    margin: 0 0 20px;
    text-align: center;
  }

  .uppercase {
    text-transform: uppercase;
  }
`;

export const BtnHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
